module.exports = __webpack_public_path__ + "img/室内应急处置机器人.7f9b7df2.png";